<template>
  <div class="">
    <div>
      <input-radio
          class="uk-form-control uk-form-control-large uk-padding uk-padding-remove-horizontal"
          v-model="selectedStoreType"
          :key="selectedStoreType"
          @change="filterChange"
          :options="storeTypes"
          :optionLabelKey="optionLabelKey"
          :optionChildrenKey="optionChildrenKey"
          name="storeType"
      />
    </div>

    <div class="uk-grid uk-child-width-expand@s">

      <div v-if="selectedStoreType != onlineStoreType">
        <div class="uk-form-control uk-form-control-large">
          <span class="uk-form-icon uk-form-icon-flip" uk-icon="search"></span>
          <input type="search" :placeholder="sfModel.BackgroundHint" class="uk-input uk-box-shadow-medium" v-model="searchQuery" @change="filterChange" aria-autocomplete="both"/>
        </div>
      </div>

      <div class="uk-margin-small-top uk-margin-remove-top@s">
        <input-checkboxes
            class="uk-form-control uk-form-control-large"
            v-model="selectedCategories"
            :key="selectedCategories"
            @change="filterChange"
            :options="categories"
            :optionLabelKey="optionLabelKey"
            :optionChildrenKey="optionChildrenKey"
            :label="l('Category')"
            name="categories"
        />
      </div>
    </div>
  </div>

</template>
<script setup>
import {onMounted, ref} from 'vue'
import InputCheckboxes from "./input-checkboxes.vue";
import {searchResults} from "./index";
import {sfUtil} from "../../util";
import InputRadio from "./input-radio.vue";

const props = defineProps({
  sfModel: Object,
  taxonomies: Object,
  additionalFilters: Object
})

const l = window.l

let additionalFilters = {...props.additionalFilters}

let taxonomies = {...props.taxonomies}
let categories = taxonomies['categories']
let storeTypes = taxonomies['storeTypes']
let onlineStoreType = taxonomies['onlineStore']


const searchQuery = ref('')
const selectedCategories = ref(new Set());
const selectedStoreType = ref();

let initialResultsHtml = null

const {
  optionLabelKey,
  optionValueKey,
  optionChildrenKey,
  getSearchParams,
  filterChildren,
  objectByValueKeys,
  findSearchResultsContainer
} = sfUtil.useBaseSearch();

const searchResultsContainer = findSearchResultsContainer()

const STORE_TYPES_KEY = 'store-types'

onMounted(() => {
  window.addEventListener('popstate', () => {
    updateSearchResults()
  })

  if (searchResultsContainer && !sfUtil.hasActiveFiltering()) {
    initialResultsHtml = searchResultsContainer.innerHTML
  }
})

let initFilterState = () => {
  let searchParams = getSearchParams()
  searchQuery.value = searchParams.get('searchQuery')
  selectedCategories.value = objectByValueKeys(new Set(searchParams.get('Categories')?.split(',')), categories)

  const searchStoreTypes = getSearchStoreTypes()

  if (searchStoreTypes.size > 1) {
    selectedStoreType.value = null
  } else if(searchStoreTypes.size === 1){
    const [store] = searchStoreTypes
    selectedStoreType.value = store
  }

}


const getSearchStoreTypes = () => {
  return objectByValueKeys(new Set(searchParams.get(STORE_TYPES_KEY)?.split(',')), storeTypes)
}


window.addEventListener('popstate', () => {
  initFilterState()
})

initFilterState()

let filterChange = () => {

  const url = new URL(window.location);

  let categoriesSearch = [...filterChildren(categories, selectedCategories.value)].map(v => v[optionValueKey]).join(',')
  let storeTypesSearch = selectedStoreType.value ? selectedStoreType.value[optionValueKey] : null

  if (categoriesSearch) {
    url.searchParams.set('Categories', categoriesSearch)
  } else {
    url.searchParams.delete('Categories')
  }

  if (storeTypesSearch) {
    url.searchParams.set(STORE_TYPES_KEY, storeTypesSearch)
  }

  if ( storeTypesSearch || categoriesSearch || searchQuery.value) {
    url.searchParams.set('searchQuery', searchQuery.value || '')
    url.searchParams.set('language', props.sfModel['Language'])

    if(!storeTypesSearch){
      url.searchParams.set(STORE_TYPES_KEY, storeTypes.map(s => s[optionValueKey]).join(','))
    }

    applyAdditionalFilters(url)
  } else {
    url.searchParams.delete('searchQuery')
  }

  if (url.searchParams.has('searchQuery')) {
    url.searchParams.set('indexCatalogue', props.sfModel['IndexCatalogue'])
  } else {
    url.searchParams.delete('indexCatalogue')
    url.searchParams.delete('searchQuery')
    url.searchParams.delete('language')
    url.searchParams.delete(STORE_TYPES_KEY)
    removeAdditionalFilters(url)
  }

  url.pathname = url.pathname.replace(sfUtil.sfPathnamePagingRegex, '')

  url.searchParams.delete('page')

  window.history.pushState({}, '', url);

  updateSearchResults()
}

let applyAdditionalFilters = (url) => {
  if (!additionalFilters) return
  for (let k in additionalFilters) {
    url.searchParams.set(k, additionalFilters[k])
  }
}

let removeAdditionalFilters = (url) => {
  if (!additionalFilters) return
  for (let k in additionalFilters) {
    url.searchParams.delete(k)
  }
}

let updateSearchResults = () => {
  initSearchResults()
  document.dispatchEvent(new Event('searchPredicateChanged'))
}

let searchResultsApp = null

let initSearchResults = () => {
  if (searchResultsApp) return
  searchResultsApp = Vue.createApp(searchResults, {initialResultsHtml})
  searchResultsApp.mount(searchResultsContainer)
  window.searchResultApp = searchResultsApp
}

</script>
